import union from 'lodash/union';
import keys from 'lodash/keys';
import filter from 'lodash/filter';

export function convertLocationToUrlQuery(location) {
    if (location == null || location.data == null) {
        return {};
    }

    let { number } = location.data;

    if (location.data.numberExtension !== null && location.data.numberExtension !== '') {
        if (Number.isNaN(parseInt(location.data.numberExtension, 10))) {
            number = `${number} ${location.data.numberExtension}`;
        } else {
            number = `${number}-${location.data.numberExtension}`;
        }
    }
    return {
        postcode: location.data.postCode,
        nr: number,
    };
}

export function locationPropsToLocationObject(props) {
    if (props.urlPostcode === null || props.urlPostcode === '' || props.urlNumber === null || props.urlNumber === '') {
        return null;
    }

    // Match postcode to regex:
    const postcodeCheck = /^[0-9]{4}\s?[a-z]{2}$/i;
    const nrCheck = /^[0-9]+[a-z0-9- ]*$/i;

    if (!postcodeCheck.test(props.urlPostcode) || !nrCheck.test(props.urlNumber)) {
        // Invalid postcode
        return null;
    }

    let number = props.urlNumber;
    let numberExtension = null;

    if (typeof props.urlNumber === 'string') {
        const numberSplit = props.urlNumber.split(' ');
        [number] = numberSplit;

        if (numberSplit.length > 1) {
            [number, numberExtension] = numberSplit;
        }
    }

    return {
        source: 'url',
        display: `${props.urlPostcode} ${props.urlNumber}`,
        data: {
            postCode: props.urlPostcode,
            number,
            numberExtension,
            lookedUp: false,
        },
    };
}

export function convertLocationToApiURL(location, addLeadingSlash = false) {
    if (location === null || location.data == null || location.data.postCode === null || location.data.number === null) {
        return '';
    }
    if (typeof location === 'undefined' || typeof location.data.postCode === 'undefined' || typeof location.data.number === 'undefined') {
        return '';
    }

    let url = '';

    if (addLeadingSlash) {
        url += '/';
    }
    url += `${location.data.postCode}/${location.data.number}`;

    if (location.data.numberExtension !== null) {
        url += location.data.numberExtension;
    }

    return url;
}

export function changedKeys(o1, o2) {
    const allKeys = union(keys(o1), keys(o2));
    return filter(allKeys, (key) => o1[key] !== o2[key]);
}
